// extracted by mini-css-extract-plugin
export var redoItem = "_nf-1";
export var redoTrigger = "_nf-0";